module.exports = __webpack_public_path__ + "img/photo-lifestyle-food-moments.34e9ddf4.png";